export default __webpack_public_path__ + "static/investment-grid-background-lakes-dbb365bbf481b794b545447bcb60e9e1.jpg";